<template>
  <div class="col-12 px-0">
    <div
      v-if="alertMessage"
      :class="'alert alert-'+alertType" role="alert"
      v-html="alertMessage"
    />
    <div v-else-if="isLoading">
      <div class="alert alert-primary">
        <div class="col-12 resp-loader loading">
          <img :src="icon" alt="VipMagnit loading icon" class="narrow-loader-icon">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Alert',
  props: ['message'],
  data () {
    return {
      icon: require('@/../public/images/icons/main/dots.svg')
    }
  },
  computed: {
    alertType () {
      return this.message.status === 'ok' ? 'success' : 'danger'
    },
    alertMessage () {
      if (this.message) {
        if (Array.isArray(this.message.msg)) {
          let msg = ''
          for (let i = 0; i < this.message.msg.length; i++) {
            msg += this.message.msg[i]
            msg += '<br>'
          }
          return msg
        }
        return this.message.msg
      }
      return null
    },
    isLoading () {
      if (!this.message) {
        return false
      }
      return this.message.status === 'loading'
    }
  }
}
</script>

<style>
  .alert {
    border: none !important;
    text-align: center;
    margin: 10px auto !important;
    border-radius: 0;
    padding: 5px 10px !important;
  }
  .alert-danger {
    background-color: rgba(230,0,29,0.75) !important;
    font-size: 16px;
    color:#ffffff !important;
    border-radius: 4px;
  }
  .alert:after{
    position: absolute;
    content: " ";
    left: -3px;
    top: -3px;
    bottom: -3px;
    right: -3px;
    outline: none !important;
    border-radius:6px;
    background-position: 0 100%, 100% 100%;
    background-repeat: no-repeat;
    background-size:  1px 100%;
    border-top: 1px solid rgba(255,255,255,0.6);
    border-bottom: 1px solid rgba(255,255,255,0.6);
    background-image:  linear-gradient(to bottom, rgba(255,255,255,0.6) 0%, #011e40 35%, #011e40 65%, rgba(255,255,255,0.6) 100%), linear-gradient(to bottom, rgba(255,255,255,0.6) 0%, #011e40 35%,#011e40 65%, rgba(255,255,255,0.6) 100%);
  }

  .alert-primary {
    background-color: rgba(204, 229, 255, 0.07) !important;
    font-size: 16px;
  }

  .alert-success {
    font-size: 16px;
    background-color: rgba(50, 138, 71, 0.1) !important;
    color: #6e9b78 !important;
  }
</style>
